const isCypress = typeof window.Cypress !== 'undefined';

export default (context) => {
  if (isCypress) {
    window.nuxt = context;
  }
};
